import React from 'react'
import CategoryComponent from '../../CategoryComponent'
import { ToastContainer } from 'react-toastify'
import { Helmet } from 'react-helmet'
import AdditionalAttribute from '../../AdditionalAttribute'

function ProjectConfiguration() {
  return (
    <>
        <section className="item_view_container bg-white">
            <Helmet><title>Project Configuration : Project</title></Helmet>
            <ToastContainer />
                <ul className="nav nav-tabs" id="myTab">
                    <li className="nav-item" role="downtimeTab">
                        <button className="nav-link active" id="category-tab" type="button" data-bs-toggle="tab" data-bs-target="#category" aria-controls="category" role="tab" aria-selected="false">Category</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link " id="additional_attribute-tab" data-bs-toggle="tab" data-bs-target="#additional_attribute"
                            type="button" role="tab" aria-controls="additional_attribute" aria-selected="true">Additional Attribute
                        </button>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane show active" id="category" aria-labelledby="category-tab">
                        <div className="tab_content_header">
                            <CategoryComponent type="project"/>
                        </div>
                    </div>
                    <div className="tab-pane" id="additional_attribute" aria-labelledby="additional_attribute">
                        <div className="tab_content_header">
                          <div className="tab_content_header">
                              <AdditionalAttribute category="project" />

                          </div>
                        </div>
                    </div>
                </div>
        </section>
    </>
  )
}

export default ProjectConfiguration